import React from 'react';
import Toastr from 'fw/components/toastr/Toastr';
import * as FormManager from './FormManager';

class Form extends React.Component {
	fieldRefs = [];

	constructor(props) {
		super(props);

		this.state = {
			disabled: props.disabled,
			form: props.values || {},
			error: null
		};
	}

	// Public API
	update = (values, callback) => {
		const updated = Object.assign(this.state.form, values);

		// Update a bunch of values
		this.setState({
			form: updated,
			error: null
		}, function () {
			this.props.onChange(updated, callback);
		});

		// Mark as dirty
		this.handleFieldDirt();
	}

	validate = () => {
		let requiredFields = true;
		let errors = [];

		// Validate Required all childen
		this.fieldRefs.forEach((child) => {
			if (child !== null && child.completed !== undefined && !child.completed()) {
				requiredFields = false;
				child.flag(false);
			}
		});

		// Some required fields not filled-in?
		if (!requiredFields) {
			this.toast.error("Please review required fields.");
			return false;
		}

		// Validate fields
		this.fieldRefs.forEach((child) => {
			if (child !== null && child.validate !== undefined) {
				const error = child.validate();

				if (error !== null && error !== undefined) {
					child.flag(false);
					errors.push(error);
				}
			}
		});

		// Custom form level validations
		if (this.props.onValidate) {
			var error = this.props.onValidate(this.state.form);

			if (error !== null && error !== undefined)
				errors.push(error);
		}

		// Show validaiton errors
		if (errors.length > 0) {
			this.toast.error(errors[0]);
			return false;
		}

		return true;
	}

	// React life cycle
	componentWillReceiveProps(nextProps) {
		this.setState({
			form: nextProps.values || {},
			disabled: nextProps.disabled
		});
	}

	componentDidMount() {
		if (this.props.unsavedChangesWarning)
			FormManager.add(this);
	}

	componentWillUnmount() {
		if (this.props.unsavedChangesWarning)
			FormManager.remove(this);
	}

	// Internal methods
	handleFieldChange = (value, name, callback) => {
		// Value contains the value of the control that has changed
		// Name is the field name that changed, which needs to be updated on the form
		// Callback is going to be called AFTER setState is completed on the form's onChange
		// on the user implementation side (so it MUST implemente the callback param)
		let form = this.state.form;
		let updated = {};

		updated = Object.assign(updated, form);
		updated[name] = value;

		this.setState({
			form: updated,
			error: null
		}, function () {
			this.props.onChange(updated, callback);
		});
	}

	handleFieldAndLabelChange = (value, label, valueField, labelField, callback) => {
		let form = this.state.form;
		let updated = {};

		updated = Object.assign(updated, form);
		updated[valueField] = value;
		updated[labelField] = label;

		this.setState({
			form: updated,
			error: null
		}, function () {
			this.props.onChange(updated, callback);
		});
	}

	handleFieldDirt = (control) => {
		if (this.props.unsavedChangesWarning)
			FormManager.dirt(this);

		this.props.onDirt && this.props.onDirt();
	}

	handleError = (error) => {
		this.setState({ error });
	}

	handleSubmit = (e) => {
		e.preventDefault();

		if (this.validate()) {
			this.setState({ dirty: false });
			this.props.onSubmit(e);
		}
	}

	handleReset = (e) => {
		e.preventDefault();
		this.props.onReset(e);
	}

	register = (child) => {
		if (child !== null)
			this.fieldRefs.push(child);
	}

	recursiveCloneChildren = (children) => {
		if (!Array.isArray(children)) {
			return this.cloneChild(children);
		}

		return React.Children.map(children, (child) => {
			return this.cloneChild(child);
		})
	}

	cloneChild = (child) => {
		if (!React.isValidElement(child))
			return child;

		if (child.type === undefined)
			return child;

		var childProps = {};

		// Only attach event handlers to our form elements
		if (child.props.formControl && child.props.name) {
			// Read value and text from each control
			let value = this.state.form[child.props.name];
			let text = "";

			// Just in case the field was not defined in the component's CTRO,
			// we assing an empty string
			if (value === undefined)
				value = "";

			// Use text only if exists
			if (child.props.label)
				text = this.state.form[child.props.label];

			// Children props
			childProps = {
				managed: true,
				value: value,
				text: text,
				disabled: this.props.disabled,
				onSubmit: this.handleSubmit,
				onFieldChange: this.handleFieldChange,
				onFieldAndLabelChange: this.handleFieldAndLabelChange,
				onDirt: this.handleFieldDirt,
				onError: this.handleError,
				ref: (c) => { child.ref && child.ref(c); this.register(c); }
			};
		}

		// Propagate other form properties to the inner react components (not just managed ones)
		childProps = {
			...childProps,
			disabled: child.props.disabled != null ? child.props.disabled : (child.props.disabled || this.props.disabled)
		};

		// Clone children
		if (child.props.children)
			childProps.children = this.recursiveCloneChildren(child.props.children);

		return React.cloneElement(child, childProps);
	}

	render() {
		// Initialize refs
		this.fieldRefs = [];

		return (
			<React.Fragment>
				<Toastr errorData={this.state.error} ref={(t) => this.toast = t}/>
				<form
					onSubmit={this.handleSubmit}
					onReset={this.handleReset}
					className={this.props.className}>
					{this.recursiveCloneChildren(this.props.children)}
				</form>
			</React.Fragment>
		)
	}
}

export default Form;



// WEBPACK FOOTER //
// ./src/fw/forms/form/Form.js